import {
  STORE_CONFIG_DATA,
  SET_PARTNER_CONFIG_DATA,
  STORE_PUBLIC_CONFIG,
  TOGGLE_APP_LOADER,
  SET_ASSESSMENT_SLUG_PUBLIC_CONFIG,
  SET_CONFIG_LOADER,
} from 'redux/actions/actionTypes';

const initialState = {
  configData: [],
  partnerConfig: {},
  publicConfigData: {},
  publicAssessmentSlugs: {},
  showAppLoader: false,
  isLoading: true,
  isConfigFetched: false,
};

export default (state = initialState, { payload, type }) => {
  switch (type) {
    case STORE_CONFIG_DATA: {
      return {
        ...state,
        configData: payload.configData,
      };
    }
    case STORE_PUBLIC_CONFIG: {
      return {
        ...state,
        ...payload,
      };
    }
    case SET_PARTNER_CONFIG_DATA: {
      return {
        ...state,
        ...payload,
      };
    }
    case TOGGLE_APP_LOADER: {
      return {
        ...state,
        showAppLoader: payload,
      };
    }
    case SET_ASSESSMENT_SLUG_PUBLIC_CONFIG: {
      return {
        ...state,
        publicAssessmentSlugs: { ...payload },
      };
    }
    case SET_CONFIG_LOADER: {
      return { ...state, isConfigFetched: payload };
    }
    default:
      return state;
  }
};
